module.exports = __webpack_public_path__ + "img/aschau_raumschale.6f153486.jpg";